<template>
    <div id="app" class="layout-wrapper">
        <router-view/>
    </div>
</template>
<script>
import device from '@/config/device'
export default {
    mounted () {
        const { $store } = this
        device(deviceType => {
            if (deviceType !== 'tablet') {
                $store.commit('setSidebar', false)
            } else {
                $store.commit('setSidebar', true)
            }
            $store.commit('setDevice', deviceType)
        })
    }
}
</script>

<style lang="less">
html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    font-size: 14px;
    background-color: #f2f3f8;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
a {
    color: inherit;
    font-style: normal;
    text-decoration: none;
}
li {
    list-style: none;
}
ul, li {
    padding: 0;
    margin: 0;
}
h1, h2, h3, h4, h5, p {
    padding: 0;
    margin: 0;
}
.clearfix {
    *zoom:1;
    &:after {
        content: ".";
        display: block;
        height:0;
        clear:both;
        visibility: hidden;
    }
}
.pt30 {
    padding-top: 30px;
}
.prl40 {
    padding-left: 40px;
    padding-right: 40px;
}
.p4080 {
    padding: 40px 0 80px 0;
}
.page-bg-white {
    background-color: #fff;
    box-shadow: 0 1px 10px rgba(0, 21, 41, 0.05);
}
.example {
    padding: 20px;
    color: white;
}
.card-tabs {
    background:#f9fafc;
    height:50px;
    position:relative;
    a {
        cursor: pointer;
        display: inline-block;
        text-align: center;
    }
    a.lps {
        font-size:16px;
        line-height:48px;
        display:inline-block;
        width:197px;
        &.on {
            background:#fff;
            border-top:2px solid #ff5f4e;
        }
    }
    a.right-link {
        height:50px;
        line-height:50px;
        position: absolute;
        right: 20px;
        top: 0;
    }
}
.card-style {
    background: #fff;
    margin-bottom: 20px;
    box-shadow: 0 0 10px rgba(0, 21, 41, 0.05);
}
</style>
